import type { Strings } from './types';

export const ko: Strings = {
  appName: '아재 스네이크',
  title: {
    duelTag: '도 전 장',
    rules: [
      '정답 글자를 순서대로 먹는다',
      '아는 사람은 직행하고, 모르는 사람은 돌아간다',
      '시간이 지나면 몸이 자라고, 정답을 먹으면 줄어든다',
      '8문제를 다 풀면 지렁이를 봉인한다',
    ],
    best: (desc, runs) => `최고 ${desc} · ${runs}판`,
    start: '시작',
    duelStart: '같은 판으로 붙는다',
    decline: '그냥 내 판 하기',
    hintDuel: '문제도 정답도 안 보인다 · 스와이프로 조종한다',
    hintSolo: '스와이프 · 방향키로 조종한다',
    packLine: (label, inference) => `팩 · ${label}${inference ? ' · 힌트가 하나씩 열린다' : ''}`,
    switchPack: (label) => `${label} 팩으로`,
  },
  band: { answerLine: (n, marks) => `정답 ${n}글자 · ${marks}` },
  hud: {
    line: (sealed, total, len, lenMax, clock, tail) =>
      `봉인 ${sealed}/${total} · 길이 ${len}/${lenMax} · ${clock} · ${tail}`,
  },
  ledger: {
    line: (total, init, byTime, byAnswer, byWord, byWrong) =>
      `길이 ${total} = 시작 ${init} · 시간 ${byTime} · 정답 ${byAnswer} · 완성 ${byWord} · 오답 ${byWrong}`,
  },
  over: {
    sealed: '봉인 완료',
    wall: '벽에 부딪혔다',
    self: '갇혔다',
    engorged: '몸이 다 찼다',
    unsealed: '문제가 다 돌았다',
    end: '판 종료',
    rank: (sealed, total, clock) => `봉인 ${sealed}/${total} · ${clock}`,
    grade: (grade) => `등급 ${grade}`,
    again: '한 판 더',
    faster: '더 빨리',
    share: '결과 공유',
    counter: '되받아치기',
    sameAgain: '같은 판 다시',
    newRun: '새 판 시작',
    newRecord: (desc) => `신기록! ${desc}`,
    best: (desc) => `최고 ${desc}`,
    appCta: '기록 · 데일리 · 스트릭은 앱에서',
    duel: (outcome, opponent) =>
      `${outcome === 'win' ? '도전 성공' : outcome === 'lose' ? '도전 실패' : '무승부'} · ${opponent}`,
  },
  revive: {
    self: '자기 몸을 물었다',
    wall: '벽에 부딪혔다',
    sub: '개그 하나 맞히면 살아난다',
    alive: '살아난다',
    timeout: '시간 초과',
    wrong: '틀렸다',
  },
  intro: [
    '스와이프 · 방향키로 움직인다',
    '시간이 지나면 몸이 자란다',
    '정답 글자를 먹으면 줄어든다',
  ],
  toast: { wrong: '썰렁…', shared: '공유했다', copied: '복사했다 — 카톡에 붙여넣기' },
  note: {
    notSame: '같은 판이 아닙니다',
    versionOld: '이 도전장은 이전 버전이라 기록을 비교하지 않는다',
    webTwice: '웹에서는 이 판을 두 번까지 — 새 판으로 시작한다',
    packUnavailable: '도전장의 팩을 받지 못해 새 판으로 시작한다',
    devBuild: '계측 비활성 (개발 빌드) — 이 링크로 측정하지 마세요',
    loading: '불러오는 중…',
  },
  card: {
    grade: {
      S: '아재 종결자',
      A: '진성 아재',
      B: '아재 입문',
      C: '아재 지망생',
      D: '개그 견습생',
      E: '아재 새싹',
      F: '첫 발',
    },
    head: (label, grade) => `🐛 아재 스네이크 — ${label} (${grade})`,
    headFirst: '🐛 아재 스네이크 — 첫 판',
    sealed: (clock) => `봉인 ${clock}`,
    sealedNoTime: '봉인',
    solved: (n, total) => `해결 ${n}/${total}`,
    revive: (n) => `부활 ${n}회`,
    nth: (n) => `이 세션 ${n}번째 판`,
    best: '🏅 내 최고',
    win: '도전 성공',
    lose: '도전 실패',
    draw: '무승부',
    url: (url) => `▸ 같은 판 도전 ${url}`,
  },
  opponent: {
    sealed: (clock) => `상대 봉인 ${clock}`,
    sealedNoTime: '상대 봉인',
    solved: (n, total) => `상대 해결 ${n}/${total}`,
    rival: '상대',
    goal: '목표',
  },
  best: {
    sealed: (clock) => `🔒 봉인 ${clock}`,
    alive: (solved, total, clock) => `🐍 ${solved}/${total} · ${clock} 생존`,
  },
  ugc: {
    submitBtn: '개그 투고',
    topBtn: '인기 개그',
    submitTitle: '아재개그 투고',
    submitHint: '문제문 6~40자 · 정답은 완성형 2~4자, 같은 글자 없이 · 승인되면 판에 나온다',
    qPlaceholder: '라면이 밤마다 잠들지 못하는 이유는?',
    aPlaceholder: '정답 (예: 불면)',
    send: '보내기',
    sent: '보냈다 — 승인되면 판에 나온다',
    myTitle: '내 투고',
    pending: '검토 중',
    approved: '승인',
    rejected: '반려',
    topTitle: '인기 개그',
    topNote: '정답은 판에서만 — 판이 끝나면 별을 줄 수 있다',
    loading: '불러오는 중…',
    empty: '아직 별을 받은 개그가 없다',
    offline: '지금은 목록을 못 받았다',
    playWeekly: '이번 주 인기 팩으로 한 판',
    back: '돌아가기',
    starTitle: '이 판의 개그에 별 주기',
    unavailable: '지금은 투고를 받지 않는다 — 잠시 뒤에 다시',
    errOffline: '연결이 안 된다 — 잠시 뒤에 다시 보낸다',
    errInvalid: '규격에 맞지 않아 받지 못했다',
    errDuplicate: '같은 정답의 개그가 이미 있다',
    errLimit: '지금은 더 보낼 수 없다 — 검토 대기 5개 · 하루 20개까지',
  },
  mute: { on: '소리 켜기', off: '소리 끄기' },
  rotate: { continue: '계속하기' },
  effects: { bang: '빵!', miss: '아깝다…' },
  crash: {
    title: '앗, 실행하다 막혔어요',
    body: '새로고침하면 대개 됩니다.',
    reload: '다시 시도',
    details: '자세히',
  },
};
